import { DoorConfiguration } from '../../configurator/DoorConfiguration';
import functionsService from '../../services/Configurator/FunctionsService';

import * as formula from '../../configurator/CalculatedCharacteristics/FrameCharacteristics';

import { Characteristic, ValueDefinition, MapCharacteristicAndValue } from '../../configurator/types';
import store from '@/store/index';
import service from '../../services/Configurator/FrameSelectionService';

const addSingleCharacteristicsFilteredOrDefaults = (s: any) => {
    const frameCharacteristics = s.model.characteristics;
    frameCharacteristics.forEach((char: any) => {
        if (char.values.length === 1) {
            const selectedCharacteristic = MapCharacteristicAndValue(char, char.values[0]);
            const currentDoorConfiguration = store.getters['configuratorModule/getCurrentDoorConfiguration'];
            currentDoorConfiguration.Add(DoorConfiguration.Frame, selectedCharacteristic);
        } else {
            var geter = store.getters['configuratorModule/getRegisteredCharacteristicsValue'];
            //console.log(geter(char.code, DoorConfiguration.Frame));
            const regChar = geter(char.code, DoorConfiguration.Frame);
            const exists = regChar.id === char.id;
            const registeredValue = char.values.filter((x: any) => x.id === regChar.value.id)[0];
            const incorrectValue = typeof registeredValue === 'undefined' ? true : false;
            if (exists === false || incorrectValue === true) {
                const valueItem = char.values[0];
                const selectedCharacteristic2 = MapCharacteristicAndValue(char, valueItem);
                const currentDoorConfiguration = store.getters['configuratorModule/getCurrentDoorConfiguration']
                currentDoorConfiguration.Add(DoorConfiguration.Frame, selectedCharacteristic2);
            }
        }
    });
};

const addOrReplaceCharacteristic = (returnedCharacteristic: any, s: any) => {
    const characteristic = returnedCharacteristic;
    const modelCharacteristics = s.model.characteristics;

    let filteredCharacteristic: any;
    filteredCharacteristic = modelCharacteristics.filter((item: any) => item.code === characteristic.code);
    if (filteredCharacteristic.length !== 0) {
        if (filteredCharacteristic[0].id === characteristic.id) {
            const characteristicIndex: number = modelCharacteristics.indexOf(filteredCharacteristic[0]);
            modelCharacteristics.splice(characteristicIndex, 1, characteristic);
        }
    } else {
        modelCharacteristics.push(characteristic);
    }
};

const getCharacteristic = (code: string, s: any) => {
    const filteredCharacteristic = s.model.characteristics.filter((characteristic: any) => characteristic.code === code)[0];

    if (typeof filteredCharacteristic !== 'undefined') {
        return filteredCharacteristic;
    } else {
        return s.defaultCharacteristicObject;
    }
};

const getDefaultState = () => {
    return {
        model: {
            modelUnlocked: false,
            characteristics: [],
            modelStatus: {
                active: false,
            },
        },
        defaultCharacteristicObject: {
            id: 0,
            description: 'Static Characteristic Description',
            code: 'CHARACTERISTIC_CODE',
            values: [
                {
                    id: 0,
                    description: 'Static Value Description',
                    value: 'No Val',
                    resource: '',
                },
            ],
        },
    }
};

const state = {
    model: {
        modelUnlocked: false,
        characteristics: [],
        modelStatus: {
            active: false,
        },
    },
    defaultCharacteristicObject: {
        id: 0,
        description: 'Static Characteristic Description',
        code: 'CHARACTERISTIC_CODE',
        values: [
            {
                id: 0,
                description: 'Static Value Description',
                value: 'No Val',
                resource: '',
            },
        ],
    },
};

const getters = {
    getFrameCharacteristics: (s: any) => s.model.characteristics,
    getCharacteristicAndValues: (s: any) => {
        return (characteristicCode: string) => getCharacteristic(characteristicCode, s);
    },
};

const actions = {
    // for test only
    async setCharacteristics(context: any, payload: any) {
        service.getFrameCharacteristics(438, '336-1714|17-70')
        .then((response: any) => {
            context.commit('updateFrameCharacteristics', response.data);
        });
    },
    setFrameCharacteristics(context: any, payload: any) {
        context.commit('updateFrameCharacteristics', payload);
    },
    async setCharacteristicDependencies(context: any, chacrateristicCode: string) {
        var frameModelCharacteristics = context.getters.getFrameCharacteristics;
        const anchor: any = frameModelCharacteristics.filter((item: any) => item.code === chacrateristicCode)[0];

        const doorConfiguration = context.rootState.configuratorModule.doorConfiguration;
        const filteredDependencies = doorConfiguration.GetDependenciesByCharacteristic(chacrateristicCode);
        await functionsService.extractDependencies(anchor.id, filteredDependencies)
        .then((response: any) => {
            context.commit('updateCharacteristicDependencies', response.data);
        });
    },
    setSingleCharacteristicsFilteredOrDefaults(context: any) {
        context.commit('updateSingleCharacteristicsFilteredOrDefaults', context);
    },
    setConfiguratorCalculatedCharacteristics(context: any) {
        context.commit('updateConfiguratorCalculatedCharacteristics', context.rootState.configuratorModule.doorConfiguration);
    },
    setDoorLeafCore(context: any) {
        context.commit('updateDoorLeafCore', context);
    },
    initFrameModule(context : any, payload : any)
    {
        context.commit('initFrameModule', payload);
    },
    resetState(context : any)
    {
        context.commit('resetState');
    }
};

const mutations = {
    updateFrameCharacteristics(s: any, payload: any) {
        payload.characteristics.forEach((element: any) => {
            addOrReplaceCharacteristic(element, s);
        });
    },
    updateCharacteristicDependencies(s: any, payload: any) {
        const characteristic = payload.characteristics[0];
        addOrReplaceCharacteristic(characteristic, s);
        addSingleCharacteristicsFilteredOrDefaults(s);
    },
    updateSingleCharacteristicsFilteredOrDefaults(s: any, context: any) {
        addSingleCharacteristicsFilteredOrDefaults(s);
        updateCalculatedCharacteristics(context.rootState.configuratorModule.doorConfiguration);
    },
    updateConfiguratorCalculatedCharacteristics(s: any, payload: any) {
        updateCalculatedCharacteristics(payload);
    },
    updateDoorLeafCore(s: any, context: any) {
        const doorLeafCoreValue = formula.getTuerkernLLTValue();
        context.rootState.configuratorModule.doorConfiguration.UpdateCharacteristicValueObject(DoorConfiguration.Frame, 'KTU_MM_TUERKERN', doorLeafCoreValue);
    },
    initFrameModule(s: any, context: any) {
        //init frame module here!
    },
    resetState(s: any)
    {
        Object.assign(s, getDefaultState());
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};

const updateCalculatedCharacteristics = (doorConfiguration: any) => {
    doorConfiguration.UpdateCharacteristicValue(DoorConfiguration.Frame, 'KTU_MM_FERMACELL_BREITE_A_TEIL', formula.calculateFermacellBreiteATeil());
};